module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"section":{"customer":"Identificação","address":"Endereço","payment":"Pagamento"},"recipient":"Destinatário","shipping":"Entrega"},"en-US":{"section":{"customer":"Identificação","address":"Address","payment":"Payment"},"recipient":"Recipient","shipping":"Shipping"}}')
  delete Component.options._Ctor
}
